import React, { useEffect, useState } from "react";
import { api } from "../../api";
import AdminSubNav from "./AdminSubNav";

function formatDate(iso) {
  try {
    return new Date(iso.replace(" ", "T") + "Z").toLocaleString();
  } catch {
    return iso;
  }
}

export default function AdminInquiriesPage() {
  const [inquiries, setInquiries] = useState(null);
  const [error, setError] = useState("");

  const load = () =>
    api.get("/api/admin/inquiries").then((d) => setInquiries(d.inquiries)).catch((e) => setError(e.message));

  useEffect(() => {
    load();
  }, []);

  const toggleStatus = async (inquiry) => {
    const nextStatus = inquiry.status === "new" ? "read" : "new";
    try {
      await api.put(`/api/admin/inquiries/${inquiry.id}/status`, { status: nextStatus });
      load();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="page">
      <h1>Admin</h1>
      <AdminSubNav active="inquiries" />
      <p className="muted">Messages submitted through the Contact us form.</p>
      {error && <div className="alert alert-error">{error}</div>}

      <table className="admin-table">
        <thead>
          <tr>
            <th>Status</th>
            <th>From</th>
            <th>Message</th>
            <th>Received</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {inquiries && inquiries.length === 0 && (
            <tr>
              <td colSpan={5} className="muted">
                No inquiries yet.
              </td>
            </tr>
          )}
          {inquiries &&
            inquiries.map((inquiry) => (
              <tr key={inquiry.id}>
                <td>
                  <span className={`badge ${inquiry.status === "new" ? "badge-warning" : "badge-success"}`}>
                    {inquiry.status === "new" ? "New" : "Read"}
                  </span>
                </td>
                <td>
                  <div>{inquiry.name}</div>
                  <div className="muted" style={{ fontSize: 12 }}>
                    {inquiry.email}
                  </div>
                </td>
                <td style={{ maxWidth: 420, whiteSpace: "pre-wrap" }}>{inquiry.message}</td>
                <td className="muted" style={{ fontSize: 13 }}>
                  {formatDate(inquiry.created_at)}
                </td>
                <td>
                  <button className="btn btn-ghost btn-sm" onClick={() => toggleStatus(inquiry)}>
                    Mark as {inquiry.status === "new" ? "read" : "new"}
                  </button>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
}
